export default "__VITE_ASSET__CJLliYXO__"